import { css, type Component } from "dreamland/core";
import { Link } from "dreamland/router";

const Nav: Component<{ active: string }, {}> = function (cx) {
	return (
		<nav class="app-nav">
            <ul>
                <li class={this.active === "home" ? "active" : ""}><Link class="nostyle material-symbols-sharp" href="/home">house</Link></li>
                <li class={this.active === "notifications" ? "active" : ""}><Link class="nostyle material-symbols-sharp" href="/notifications">notifications</Link></li>
                <li class={this.active === "profile" ? "active" : ""}><Link class="nostyle material-symbols-sharp" href="/profile">account_box</Link></li>
                <li class={this.active === "settings" ? "active" : ""}><Link class="nostyle material-symbols-sharp" href="/settings">settings</Link></li>
            </ul>
            <button class="primary material-symbols-sharp" id="post-fab" on:click={() => {
                alert("todo: compose functionality");
            }}>
                edit_note
            </button>
        </nav>
	);
};

export default Nav;
